"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _vlpTableCarousel = _interopRequireDefault(require("../vlp-table-carousel.css"));
var ImageCard = function ImageCard(_ref) {
  var imageUrl = _ref.imageUrl,
    altText = _ref.altText,
    description = _ref.description,
    title = _ref.title,
    disclaimerData = _ref.disclaimerData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].card
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: _vlpTableCarousel["default"].cardImage,
    src: imageUrl,
    alt: altText
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: title,
    className: _vlpTableCarousel["default"].cardTitle,
    tag: "p",
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: description,
    className: _vlpTableCarousel["default"].cardDescription,
    tag: "p",
    disclaimerData: disclaimerData
  }));
};
ImageCard.defaultProps = {
  description: '',
  title: ''
};
var _default = ImageCard;
exports["default"] = _default;